//export const BASE_URL = 'https://jsdz6bisv3.execute-api.us-east-1.amazonaws.com/dev/v1/api';//DEV
export const BASE_URL = 'https://p4nz0gynl8.execute-api.us-east-1.amazonaws.com/dev/v1/api';//PROD